import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";
import { ImageFormats } from "../../../components/forms/libs/data/imageFormatTypes";

const initState = {
    emailAddress: '',
    // firstName: null,
    // lastName: null,
    displayName: null,
    company: null,
    eXCOPosition: null,
    designation: null,
    displayPhotoExpFile: null,
    linkedIn: null
};

export const AddEXCOMemberData = {
    name: "AddEXCOMemberData",
    initialState: initState,
    section: [
        {
            title: "AddEXCOMember",
            row: {},
            style: {
                sectionStyle: "row verticle-form",
            },
            rowGroup: [
                {
                    groupLabel: "AddEXCOMember",
                    style: {
                        groupStyle: "col-lg-12 col-md-12 mb-2",
                    },
                    groupWrapper: <div className="form-card row"></div>,
                    fields: [


                        {
                            id: "displayPhotoExpFile",
                            label: "Display Photo",
                            Field_Name: "Display Photo",
                            fieldType: FormFieldTypes.IMAGE,
                            dataField: "displayPhotoExpFile",
                            fieldSetting: {
                                placeholder: "Display Image",
                                allowMultipleFiles: false,
                                acceptedImageFormats: [
                                    ImageFormats.JPEG,
                                    ImageFormats.BMP,
                                    ImageFormats.JPG,
                                    ImageFormats.PNG,
                                    ImageFormats.WEBP,
                                ],
                                minFileSizeInMB: 0, // Minimum File size in MB
                                maxFileSizeInMB: 8, // Maximum File size in MB
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                            style: {
                                containerCss: "col-lg-12 col-md-12 mb-2 validation-text-fileuploader",
                            },
                        },
                        {
                            id: "emailAddress",
                            Field_Name: "Email Address",
                            fieldType: FormFieldTypes.INPUT,
                            label: "Email Address",
                            dataField: "emailAddress",
                            fieldSetting: {
                                placeholder: "",
                                allowSpace: true,
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                            style: {
                                containerCss: "col-lg-12 col-md-12 mb-2",
                            },
                        },
                        // {
                        //     id: "firstName",
                        //     label: "First Name",
                        //     Field_Name: "First Name",
                        //     fieldType: FormFieldTypes.INPUT,
                        //     dataField: "firstName",
                        //     fieldSetting: {
                        //         allowSpace: true,
                        //         isDisable: false,
                        //         placeholder: ''
                        //     },
                        //     validation: [{ type: validationTypes.REQUIRE }],
                        //     style: {
                        //         containerCss: "col-lg-6 col-md-6 mb-2",
                        //     },
                        // },
                        // {
                        //     id: "lastName",
                        //     label: "Last Name",
                        //     Field_Name: "Last Name",
                        //     fieldType: FormFieldTypes.INPUT,
                        //     dataField: "lastName",
                        //     fieldSetting: {
                        //         allowSpace: true,
                        //         isDisable: false,
                        //         placeholder: ''
                        //     },
                        //     validation: [{ type: validationTypes.REQUIRE }],
                        //     style: {
                        //         containerCss: "col-lg-6 col-md-6 mb-2",
                        //     },
                        // },
                        {
                            id: "displayName",
                            label: "Display Name",
                            Field_Name: "Display Name",
                            fieldType: FormFieldTypes.INPUT,
                            dataField: "displayName",
                            fieldSetting: {
                                allowSpace: true,
                                isDisable: false,
                                placeholder: ''
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                            style: {
                                containerCss: "col-lg-6 col-md-6 mb-2",
                            },
                        },
                        {
                            id: "company",
                            label: "Company",
                            Field_Name: "Compnay",
                            fieldType: FormFieldTypes.INPUT,
                            dataField: "company",
                            fieldSetting: {
                                allowSpace: true,
                                isDisable: false,
                                placeholder: ''
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                            style: {
                                containerCss: "col-lg-6 col-md-6 mb-2",
                            },
                        },
                        {
                            id: "eXCOPosition",
                            label: "EXCO Position",
                            Field_Name: "EXCO Position",
                            fieldType: FormFieldTypes.SELECT,
                            dataField: "eXCOPosition",
                            fieldSetting: {
                                placeholder: "Select",
                                allowSpace: true,
                                options: [],
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                            style: {
                                containerCss: "col-lg-6 col-md-6 mb-2",
                            },
                        },
                        {
                            id: "designation",
                            label: "Designation",
                            Field_Name: "Designation",
                            fieldType: FormFieldTypes.INPUT,
                            dataField: "designation",
                            fieldSetting: {
                                allowSpace: true,
                                placeholder: "",
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                            style: {
                                containerCss: "col-lg-6 col-md-6 mb-2",
                            },
                        },
                        {
                            id: "linkedIn",
                            label: "LinkedIn",
                            Field_Name: "LinkedIn",
                            fieldType: FormFieldTypes.INPUT,
                            dataField: "linkedIn",
                            fieldSetting: {
                                allowSpace: true,
                                placeholder: "",
                            },
                            // validation: [{ type: validationTypes.REQUIRE }],
                            style: {
                                containerCss: "col-lg-6 col-md-6 mb-2",
                            },
                        },


                    ],
                },
            ],
        },
    ],
};
